import { Button } from '@design-system';
import { CareAdjustmentChoices } from '../components/care-adjustment-choices';
import { CareScenarioCard } from '../components/care-scenario-card';
import { StepFrame } from '../components/step-frame';
import { useCareAdjustments } from '../hooks/use-care-adjustments';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepProps } from './step-props';

export function ScenarioStep({ clientId }: ConsumerStepProps) {
  const { goTo, back, finish, returnTo } = useConsumerFlow(clientId);
  const care = useCareAdjustments(clientId);
  if (!care.scenario) return null;

  const handleContinue = () => {
    care.saveAdjustments();
    if (returnTo) finish('review');
    else goTo('searching');
  };

  return (
    <StepFrame
      step="scenario"
      title="Here’s what your future care could look like"
      subtitle="We filled this in from your results and where you’d prefer to receive care. It’s a starting point, and you can keep our estimate."
      onBack={() => back('household')}
      helpLabel="I’m not sure about these assumptions"
      help={
        <>
          <CareAdjustmentChoices
            adjustments={care.adjustments}
            careHoursByAmount={care.careHoursByAmount}
            familyHoursByHelp={care.familyHoursByHelp}
            onCareAmountChange={care.setCareAmount}
            onFamilyHelpChange={care.setFamilyHelp}
          />
          <Button
            variant="link"
            className="self-start px-0"
            onClick={() => {
              care.saveAdjustments();
              goTo('care-setting', { returnTo: 'scenario' });
            }}
          >
            Change where you’d receive care
          </Button>
        </>
      }
      primary={{ label: returnTo ? 'Back to your plan' : 'Continue to coverage', onClick: handleContinue }}
      next={care.isCustom ? 'your custom assumptions carry into coverage.' : 'find insurance options.'}
    >
      <CareScenarioCard scenario={care.scenario} isCustom={care.isCustom} />
    </StepFrame>
  );
}
